export default "__VITE_ASSET__S0PkLuE0__"